module.exports = __webpack_public_path__ + "static/psychic-interior-02-b317dc99ccae38f92aadc3970ae524ba.jpg";